import { createFileRoute, redirect } from "@tanstack/react-router";

// An older address of the Team page, which earlier emails and bookmarks carry.
export const Route = createFileRoute("/_authed/$org/settings/members")({
  beforeLoad: ({ params, location }) => {
    throw redirect({ href: `/${encodeURIComponent(params.org)}/team/members${location.searchStr}`, replace: true });
  },
});
